<template>
  <div class="service-plan">

    <admin-filter
      :items="filterData"
      :itemFiltered.sync="filtered"
      @getData="getDataFromServer"
      title="서비스별 플랜 이용량 조회"
      desc="서비스별 플랜의 이용 현황을 조회할 수 있습니다."
    ></admin-filter>


    <admin-table :field_list="tableData"
                 :items="tableItems"
                 :filtered="filtered"
                 :allCount="allCount"
                 :filteredCount="filteredCount"
                 @getData="getDataFromServer"
                 @ordering="ordering"
                 :table_width="1650"
                 @selPageLength="selPageLength">
      <div slot="usage" slot-scope="props">
        <template v-if="props.item.service_usage">
          <div v-for="(kor_name, key, p_idx) in service_plan" :key="`p-${p_idx}`">
            <span>{{ kor_name }}: </span>
            <span>
              <span v-if="key!=='front' && key!=='template'"
                    :style="overStyle(props.item.service_usage[key])">{{ props.item.service_usage[key] }}</span>
            </span>
          </div>
        </template>
        <template v-else>서비스 배포 후 확인 가능</template>
      </div>
    </admin-table>

  </div>
</template>

<script>
  import ListMixin from '@/mixins/ListMixin'

  export default {
    name: 'ServicePlanManagementList',
    mixins: [
      ListMixin
    ],
    data() {
      return {
        service_plan: {
          user: '회원가입수',
          // front: '프론트 서비스 제공 범위',
          partner: '파트너등록수',
          product: '상품 등록수',
          category: '상품 카테고리수',
          // template: '블록템플릿 무제한 이용권',
          admin_account: '관리자 계정 갯수',
        }
      }
    },
    created() {
      this.init();
    },

    methods: {
      init () {
        this.initializing('launchpack_service_plan_management', 'launchpack/service/service_plan');
      },
      getDataFromServer() {
        this.getData();
      },
      overStyle(value) {
        let style = {};
        if(value) {
          let val1 = value.split('/')[0]
          let val2 = value.split('/')[1]
          if(parseInt(val1)>parseInt(val2)) style.color = 'red'
        }
        return style;
      }
    }
  }
</script>

<style lang="stylus" type="stylus" scoped>
  .service-plan .admin-table td > div
    -webkit-line-clamp unset
</style>
